import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-hbs',
    templateUrl: './page-hbs.component.html',
    styleUrls: ['./page-hbs.component.css'],
    standalone: false
})
export class PageHbsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
